import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { NativePriceFragment } from "@/components/price/NativePrice.fragment"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"
import { UsdPriceFragment } from "@/components/price/UsdPrice.fragment"
import { TokenSwapPriceFragment } from "../TokenSwapActivityTable/cells/TokenSwapPrice.fragment"
import { TokenSwapRouteFragment } from "../TokenSwapRoute/TokenSwapRoute.fragment"

export const TokenSwapActivityAnnotationFragment = graphql(
  `
  fragment TokenSwapActivityAnnotation on TokenSwapActivity {
    timestamp
    swapProtocol {
      identifier
    }
    fromToken {
      usd
      token {
        unit
        address
        symbol
        chain {
          identifier
        }
      }
      ...TokenPrice
      ...UsdPrice
      ...NativePrice
    }
    toToken {
      usd
      token {
        unit
        address
        symbol
        chain {
          identifier
        }
      }
      ...TokenPrice
      ...UsdPrice
      ...NativePrice
    }
    sender {
      ...AccountLockup
    }
    ...TokenSwapPrice
    ...TokenSwapRoute
  }
`,
  [
    AccountLockupFragment,
    TokenPriceFragment,
    TokenSwapPriceFragment,
    UsdPriceFragment,
    NativePriceFragment,
    TokenSwapRouteFragment,
  ],
)
